<template>
	<v-btn icon small text @click="share_screen" :color="sharing_screen ? 'green' : 'black' ">
		<v-icon small>mdi-monitor-share</v-icon>
	</v-btn>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">

	import Vuex from "vuex";
	export default {
		name: "ScreenShareButton", 
		props: {
			room: {},
			settings: {},
			btnColor: {type: String, default: "black"}
		},
		data: () => {
			return {
			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user,
			}), 
			sharing_screen(){
				return this.settings.sharing_screen || false
			},
		},
		methods: {
			share_screen(){
				var data = {
					sharing_screen: !this.sharing_screen
				}
				this.$store.dispatch("updateDoc", {
					doc: `videoRooms/${this.room}/participants/${this.user.uid}`, 
					action: "update", 
					data: data 
				})
			}

		}
	}
// </script>"